import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = {
    class: "title-group",
    style: { "max-width": "fit-content" }
};
const _hoisted_3 = { class: "rotate m-0 ps-2" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-edit" }, null, -1);
const _hoisted_6 = { class: "card h-100" };
const _hoisted_7 = {
    class: "card-body",
    style: { "color": "#464646" }
};
const _hoisted_8 = { class: "card-title" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_11 = { key: 1 };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_14 = /*#__PURE__*/ _createTextVNode("  ");
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_17 = { key: 2 };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("strong", null, "Planned room:", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_20 = { key: 3 };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("strong", null, "Current room:", -1);
const _hoisted_22 = { class: "card-footer" };
const _hoisted_23 = {
    key: 0,
    class: "d-flex flex-wrap gap-2"
};
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1);
const _hoisted_25 = /*#__PURE__*/ _createTextVNode(" Info ");
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-edit" }, null, -1);
const _hoisted_27 = /*#__PURE__*/ _createTextVNode(" Edit ");
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash" }, null, -1);
const _hoisted_29 = /*#__PURE__*/ _createTextVNode(" Delete ");
import { ref, computed } from 'vue';
import TeamView from '../Teams/TeamView';
import TeamEdit from '../Teams/TeamEdit';
import { Team, getScoresForTeam, getPrintedDurationTime } from '@/types/teams';
import { useToast } from 'vue-toastification';
import { ModalBox, Button } from '@/components/UI';
import { ScanTeamButton } from '@/components/Schedule';
import { getCurrentInstance } from 'vue';
import TeamBadge from '@/components/UI/TeamBadge/TeamBadge.vue';
import Icon from '@/components/UI/Icon/Icon.vue';
import { GroupEdit } from '.';
import { GroupState } from '@/types/group';
import { cloneDeep } from 'lodash';
import { useGroups } from '@/compositions/useGroups';
import useClock from '@/compositions/useClock';
import { useTeams } from '@/compositions/useTeams';
export default /*#__PURE__*/ _defineComponent({
    props: {
        groupId: null,
        group: null,
        actions: null
    },
    setup(__props) {
        const props = __props;
        const { proxy } = getCurrentInstance();
        const store = proxy === null || proxy === void 0 ? void 0 : proxy.$store;
        const { updateGroup } = useGroups();
        const { createTeam, updateTeam } = useTeams();
        const actions = computed(() => { var _a; return (_a = props.actions) !== null && _a !== void 0 ? _a : []; });
        const toast = useToast();
        const editTeam = ref(null);
        const infoTeam = ref(null);
        const editVisible = ref(false);
        const editGroup = ref(null);
        const componentKey = ref(0);
        const { nowDate } = useClock();
        async function openEditPopup() {
            editGroup.value = cloneDeep(props.group);
        }
        async function updateGroupDialog(action) {
            if (editGroup.value === null)
                return;
            const successmessage = action === 'moved'
                ? `Group moved to ${editGroup.value.state}`
                : `Team ${editGroup.value.name} has been saved`;
            const failmessage = action === 'moved'
                ? 'Could not move group, '
                : 'Could not update group, ';
            try {
                await updateGroup(props.groupId, {
                    name: editGroup.value.name,
                    num_slots: editGroup.value.num_slots
                });
                toast.success(successmessage);
            }
            catch (error) {
                toast.error(failmessage + error);
            }
            editGroup.value = null;
            componentKey.value += 1;
        }
        async function updateTeamWithToast(team) {
            const successmessage = `Team ${team.name} has been saved`;
            const failmessage = 'Could not update team, ';
            try {
                await updateTeam(team);
                toast.success(successmessage);
            }
            catch (error) {
                toast.error(failmessage + error);
            }
            editVisible.value = false;
            componentKey.value += 1;
        }
        async function deleteTeam(teamid) {
            console.log('Deleting team', teamid);
            try {
                await store.direct.dispatch.teams.delete(teamid);
                toast.success(`Team has been deleted`);
                componentKey.value += 1;
            }
            catch (error) {
                if (error instanceof Error) {
                    toast.error(error.message);
                }
            }
        }
        const openAddTeamPopup = async () => {
            editTeam.value = Team.empty(props.groupId);
            editTeam.value.name = props.group.name + ' ' + (Object.keys(props.group.teams).length + 1);
            editTeam.value.group = props.groupId;
            await createTeam(editTeam.value);
            editVisible.value = true;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", { key: componentKey.value }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", null, [
                            _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.group.name), 1),
                            _hoisted_4,
                            (_unref(actions).includes('edit'))
                                ? (_openBlock(), _createBlock(_unref(Button), {
                                    key: 0,
                                    variant: "success",
                                    onClick: openEditPopup
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_5
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            (_unref(actions).includes('edit') && __props.group.state == _unref(GroupState).Waiting)
                                ? (_openBlock(), _createBlock(_unref(Button), {
                                    key: 1,
                                    variant: "success",
                                    onClick: openAddTeamPopup
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(Icon, { name: "plus" })
                                    ]),
                                    _: 1
                                }))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.group.teams, (team) => {
                        var _a, _b;
                        return (_openBlock(), _createElementBlock("div", {
                            class: "col-12 col-md-6 col-lg-3 mb-4",
                            key: team.id
                        }, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h5", _hoisted_8, _toDisplayString(team.name), 1),
                                    (__props.group.state != _unref(GroupState).Waiting)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                            _createVNode(Icon, { name: 'trophy' }),
                                            _createTextVNode("  " + _toDisplayString(Object.values(_unref(getScoresForTeam)(team)).reduce((sum, current) => sum + current, 0)), 1),
                                            _hoisted_10
                                        ]))
                                        : _createCommentVNode("", true),
                                    (__props.group.state != _unref(GroupState).Waiting)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                            _createVNode(Icon, { name: 'gamepad' }),
                                            _createTextVNode(" " + _toDisplayString((_a = __props.group.num_slots) !== null && _a !== void 0 ? _a : 0), 1),
                                            _hoisted_12
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("span", null, [
                                        _createVNode(Icon, { name: 'users' }),
                                        _createTextVNode(" " + _toDisplayString(team.members.length), 1),
                                        _hoisted_13
                                    ]),
                                    _createElementVNode("span", null, [
                                        _createVNode(Icon, { name: 'id-card' }),
                                        _hoisted_14,
                                        _createVNode(TeamBadge, {
                                            rfid: (_b = team.members[0]) === null || _b === void 0 ? void 0 : _b.rfid,
                                            size: 1
                                        }, null, 8, ["rfid"]),
                                        _hoisted_15
                                    ]),
                                    _createElementVNode("span", null, [
                                        _createVNode(Icon, { name: 'hourglass-half' }),
                                        _createTextVNode(" " + _toDisplayString(_unref(getPrintedDurationTime)(team)), 1),
                                        _hoisted_16
                                    ]),
                                    (__props.group.state == _unref(GroupState).Waiting)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                            _hoisted_18,
                                            _createTextVNode(" " + _toDisplayString(team.schedule[0]), 1),
                                            _hoisted_19
                                        ]))
                                        : _createCommentVNode("", true),
                                    (__props.group.state == _unref(GroupState).Active)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                            _hoisted_21,
                                            _createTextVNode(" " + _toDisplayString(__props.group.getRoomId(team.id, _unref(nowDate))), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_22, [
                                    (_unref(actions).length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            (_unref(actions).includes('info'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 0,
                                                    variant: "info",
                                                    onClick: ($event) => (infoTeam.value = team)
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_24,
                                                        _hoisted_25
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (_unref(actions).includes('edit'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 1,
                                                    "data-cy": `edit_${team.id}_${__props.group.state}`,
                                                    variant: "success",
                                                    onClick: ($event) => { editTeam.value = team; editVisible.value = true; }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_26,
                                                        _hoisted_27
                                                    ]),
                                                    _: 2
                                                }, 1032, ["data-cy", "onClick"]))
                                                : _createCommentVNode("", true),
                                            (_unref(actions).includes('delete'))
                                                ? (_openBlock(), _createBlock(_unref(Button), {
                                                    key: 2,
                                                    variant: "danger",
                                                    onClick: ($event) => (deleteTeam(team.id))
                                                }, {
                                                    default: _withCtx(() => [
                                                        _hoisted_28,
                                                        _hoisted_29
                                                    ]),
                                                    _: 2
                                                }, 1032, ["onClick"]))
                                                : _createCommentVNode("", true),
                                            (_unref(actions).includes('scan'))
                                                ? (_openBlock(), _createBlock(_unref(ScanTeamButton), {
                                                    key: 3,
                                                    team: team
                                                }, null, 8, ["team"]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]));
                    }), 128))
                ]),
                (infoTeam.value !== null)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 0,
                        title: "Team Overview",
                        size: "lg",
                        onSubmit: _cache[0] || (_cache[0] = ($event) => (infoTeam.value !== null && _unref(updateTeam)(infoTeam.value))),
                        onClose: _cache[1] || (_cache[1] = ($event) => (infoTeam.value = null))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TeamView), { team: infoTeam.value }, null, 8, ["team"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (editVisible.value && editTeam.value !== null)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 1,
                        title: "Edit team",
                        size: "lg",
                        submitButtonTitle: "Save",
                        onSubmit: _cache[2] || (_cache[2] = ($event) => (editTeam.value !== null && updateTeamWithToast(editTeam.value))),
                        onClose: _cache[3] || (_cache[3] = ($event) => (editVisible.value = false))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(TeamEdit), { team: editTeam.value }, null, 8, ["team"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (editGroup.value !== null)
                    ? (_openBlock(), _createBlock(_unref(ModalBox), {
                        key: 2,
                        title: "Edit Group",
                        size: "lg",
                        submitButtonTitle: "Save",
                        onSubmit: _cache[5] || (_cache[5] = ($event) => (updateGroupDialog('edit'))),
                        onClose: _cache[6] || (_cache[6] = ($event) => (editGroup.value = null))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(GroupEdit), {
                                group: editGroup.value,
                                mode: "edit",
                                groupId: props.groupId,
                                onClose: _cache[4] || (_cache[4] = ($event) => { editGroup.value = null; componentKey.value += 1; })
                            }, null, 8, ["group", "groupId"])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
